<ng-container *transloco="let t">
  @if (snapshotDate() && sovData() && brandSelection()) {
    <div class="flex items-center justify-center py-8">
      @if (!loading()) {
        <div class="flex w-full items-start gap-8 rounded-lg border px-6">
          <div class="my-2 w-1/4">
            <IChart [config]="donutChartConfig()" [data]="data()" />
          </div>
          <div class="mt-4 flex grow flex-col">
            <div class="flex w-full justify-between">
              <div class="mt-2 flex items-start gap-2">
                <span class="font-bold"
                  >{{
                    dataMode() === PieChartDataMode.SNAPSHOT ? t("sov-pie-chart.snapshot") : t("sov-pie-chart.global")
                  }}
                </span>
                <span></span>
                <span class="text-main flex items-center gap-1 pt-0.5 text-sm font-bold">
                  <IIcon name="calendar" class="text-lg" />
                  <span>
                    @if (dataMode() === PieChartDataMode.GLOBAL) {
                      {{ selectedDateRange().start.toJSDate() | date: "shortDate" : undefined : locale() }} -
                      {{ selectedDateRange().end.toJSDate() | date: "shortDate" : undefined : locale() }}
                    } @else {
                      {{ snapshotDate() && locale() ? (snapshotDate() | date: undefined : locale()) : "--/--/----" }}
                    }
                  </span>
                </span>
              </div>
              <div class="mb-2 flex flex-col items-end">
                <ISwitchButton
                  class="rank-switch mb-2"
                  [options]="[PieChartDataMode.SNAPSHOT, PieChartDataMode.GLOBAL]"
                  [buttonTexts]="[t('sov-pie-chart.snapshot'), t('sov-pie-chart.global')]"
                  [buttonTooltips]="[
                    t('sov-pie-chart.sets_share_of_voice_by_brand_on_the_selected_snapshot_date'),
                    t('sov-pie-chart.sets_share_of_voice_by_brand_on_the_selected_date_range'),
                  ]"
                  [selected]="dataMode()"
                  (buttonClicked)="changeDataMode($event)"
                ></ISwitchButton>
                <div [iTooltip]="t('sov-pie-chart.change_snapshot_tooltip')"></div>
              </div>
            </div>
            <div class="mt-12 grid grow grid-cols-2 gap-x-9 max-[75rem]:grid-cols-1">
              @for (b of data(); track $index) {
                <div class="mb-4 flex justify-between border-b border-b-gray-300 pb-3 text-xs leading-4 font-bold">
                  <div class="flex items-center">
                    <div
                      class="color-badge mr-3"
                      [style.background-color]="brandColors()?.get(b.brand) ?? otherBrandColor"
                    ></div>
                    <div>{{ b.brand }}</div>
                  </div>
                  <span>{{ b.value | number: "1.0-0" }}%</span>
                </div>
              }
            </div>
          </div>
        </div>
      } @else {
        <ISpinner [display]="true" />
      }
    </div>
  }
</ng-container>
